// Constantes e helpers compartilhados pelo quadro, calendário e ações das Demandas.

export const ROXO = '#6B2C5C';

export const TIPOS = [
  { v: 'campanha', label: 'Campanha / data comemorativa', icon: 'bi-megaphone' },
  { v: 'arte_campanha', label: 'Arte de campanha', icon: 'bi-palette' },
  { v: 'video', label: 'Vídeo', icon: 'bi-camera-reels' },
  { v: 'vaga', label: 'Vaga de emprego', icon: 'bi-person-plus' },
  { v: 'foto_perfil', label: 'Foto de perfil', icon: 'bi-person-bounding-box' },
  { v: 'cracha', label: 'Crachá / cartão', icon: 'bi-person-vcard' },
  { v: 'anuncio', label: 'Anúncio / mídia', icon: 'bi-badge-ad' },
  { v: 'oferta_erp', label: 'Cadastro de oferta / preço', icon: 'bi-tags' },
  { v: 'impressao', label: 'Impressão', icon: 'bi-printer' },
  { v: 'outro', label: 'Outro', icon: 'bi-three-dots' },
];
export const TIPO = Object.fromEntries(TIPOS.map(t => [t.v, t]));

export const COLUNAS = [
  { status: 'a_fazer', label: 'A fazer', icon: 'bi-inbox', cor: '#8a6d00', bg: '#fff8e1' },
  { status: 'fazendo', label: 'Fazendo', icon: 'bi-hourglass-split', cor: '#1d5fa8', bg: '#e8f1fb' },
  { status: 'feito', label: 'Feito', icon: 'bi-check-circle-fill', cor: '#1f7a3d', bg: '#e9f6ee' },
];
export const ORDEM_STATUS = COLUNAS.map(c => c.status);

// Visual de cada etapa (inclui as que não são coluna do quadro)
export const ETAPAS = {
  planejada: { label: 'Planejada', icon: 'bi-calendar3', cor: '#6B2C5C', bg: '#F5EBF2' },
  ...Object.fromEntries(COLUNAS.map(c => [c.status, c])),
  cancelada: { label: 'Cancelada', icon: 'bi-x-circle', cor: '#777', bg: '#eee' },
};

// Ações que a demanda pode ter ("o que ela vai fazer"). Espelha o catálogo do backend (routes/demandas.js).
// gera: o que o botão Gerar cria — campanha, land, ou (padrão) uma demanda filha no quadro.
export const ACOES = [
  { v: 'campanha', label: 'Campanha de produtos', icon: 'bi-megaphone', gera: 'campanha' },
  { v: 'plaquinhas', label: 'Plaquinhas', icon: 'bi-tag', precisaCampanha: true },
  { v: 'checklist', label: 'Checklist das lojas', icon: 'bi-list-check', precisaCampanha: true },
  { v: 'oferta_erp', label: 'Cadastro de oferta no ERP', icon: 'bi-tags' },
  { v: 'landpage', label: 'Landpage', icon: 'bi-window', gera: 'land' },
  { v: 'story', label: 'Story / redes sociais', icon: 'bi-instagram' },
  { v: 'cartaz', label: 'Cartaz A3 / A4', icon: 'bi-file-earmark-image' },
  { v: 'outdoor', label: 'Outdoor', icon: 'bi-signpost-2' },
  { v: 'video', label: 'Vídeo', icon: 'bi-camera-reels' },
  { v: 'anuncio', label: 'Anúncio pago', icon: 'bi-badge-ad' },
  { v: 'impressao', label: 'Impressão', icon: 'bi-printer' },
];
export const ACAO = Object.fromEntries([...ACOES, { v: 'outro', label: 'Outra', icon: 'bi-plus-circle' }].map(a => [a.v, a]));

export const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

// 'Hoje' no fuso do Brasil (toISOString usaria UTC e viraria o dia às 21h)
export const hoje = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });
export const somaDias = (iso, n) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
// dd/mm no ano corrente; dd/mm/aa fora dele (senão 30/06/2027 parece junho deste ano)
export const fmtData = (iso) => {
  if (!iso) return '';
  const [a, m, d] = iso.split('-');
  return a === hoje().slice(0, 4) ? `${d}/${m}` : `${d}/${m}/${a.slice(2)}`;
};
export const fmtPeriodo = (di, df) => (!di ? '' : (df && df !== di ? `${fmtData(di)} a ${fmtData(df)}` : fmtData(di)));

// Intervalo que a demanda ocupa no calendário: período (se tiver) senão o prazo
export function intervalo(d) {
  const ini = d.data_inicio || d.prazo;
  if (!ini) return null;
  return { ini, fim: d.data_fim || ini };
}

export function situacaoPrazo(d) {
  if (!d.prazo || d.status === 'feito' || d.status === 'cancelada') return null;
  const h = hoje();
  if (d.prazo < h) return { label: `Atrasada · ${fmtData(d.prazo)}`, cor: '#b23b3b', bg: '#fdeeee' };
  if (d.prazo === h) return { label: 'Hoje', cor: '#8a6d00', bg: '#fff3c4' };
  if (d.prazo === somaDias(h, 1)) return { label: 'Amanhã', cor: '#8a6d00', bg: '#fff8e1' };
  return { label: fmtData(d.prazo), cor: '#555', bg: '#f1f1f1' };
}
